export const knownTrackingParameters =
	[
		'utm_source',
		'utm_medium',
		'utm_campaign',
		'utm_term',
		'utm_content',
		'fbclid',
		'ndclid',
		'gclid'
	];

export const trackingParameterToPropertyMap = {
	'utm_source': 'UtmSource',
	'utm_medium': 'UtmMedium',
	'utm_campaign': 'UtmCampaign',
	'utm_term': 'UtmTerm',
	'utm_content': 'UtmContent',
	'fbclid': 'Fbclid',
	'ndclid': 'Ndclid',
	'gclid': 'Gclid'
};